var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FiTrash2 } from 'react-icons/fi';
import { Table, TableHead, TableBody, TableRow, TableCell, TableHeadCell, TableCellContent } from './BrandTable';
import colors from '../utils/colors';
import BlueSelect from './BlueSelect';
import CheckBox from './BrandCheckBox';
import BurgerMenu from './BurgerMenu';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: auto;\n  margin-bottom: 30px;\n"], ["\n  display: block;\n  width: auto;\n  margin-bottom: 30px;\n"])));
var TableContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0px 10px;\n"], ["\n  margin: 0px 10px;\n"])));
var TableTitle = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 12px;\n  color: ", ";\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: 0.36px;\n  line-height: 12px;\n  text-transform: uppercase;\n  margin-top: 16px;\n"], ["\n  height: 12px;\n  color: ", ";\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: 0.36px;\n  line-height: 12px;\n  text-transform: uppercase;\n  margin-top: 16px;\n"])), colors.GRAY);
var EmptyContentTitle = styled.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 8px 16px;\n  color: ", ";\n  font-size: 14px;\n  text-transform: uppercase;\n  font-weight: 600;\n  text-align: center;\n"], ["\n  padding: 8px 16px;\n  color: ", ";\n  font-size: 14px;\n  text-transform: uppercase;\n  font-weight: 600;\n  text-align: center;\n"])), function (props) { return props.theme.primaryColor || colors.BLUE; });
var SelectableRow = styled(TableRow)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  background-color: ", ";\n  &:hover {\n    cursor: pointer;\n  }\n"])), function (p) { return (p.isSelected ? colors.TP_BLUE : colors.WHITE); });
var NameCell = function (props) {
    var editBox = React.createRef();
    var _a = useState(false), cellEditable = _a[0], setCellEditable = _a[1];
    var _b = useState(props.owner.name), ownerNameCopy = _b[0], setName = _b[1];
    var updateOwner = function () { return __awaiter(void 0, void 0, void 0, function () {
        var space;
        return __generator(this, function (_a) {
            if (ownerNameCopy != '') {
                props.owner.name = ownerNameCopy;
                space = props.owner.space;
                props.onOwnerRename(props.owner, space);
            }
            return [2 /*return*/];
        });
    }); };
    var handleOutsideClick = function (e) {
        if (editBox.current && !editBox.current.contains(e.target)) {
            setCellEditable(false);
        }
    };
    useEffect(function () {
        document.addEventListener('mousedown', handleOutsideClick);
        return function () {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    });
    var handleInput = function (event) {
        if (event.keyCode === 13) {
            setCellEditable(false);
            updateOwner();
        }
    };
    return !cellEditable ? (React.createElement(TableCellContent, { onClick: function () { return setCellEditable(!cellEditable); }, style: { flex: 2, textAlign: 'left' } }, props.owner.name)) : (React.createElement("input", { type: "text", value: ownerNameCopy, ref: editBox, onKeyUp: handleInput, onChange: function (e) { return setName(e.target.value); } }));
};
var EmployeeLists = function (props) {
    var selectedOwner = props.selectedOwner, onOwnerSelect = props.onOwnerSelect, assignedOwners = props.assignedOwners, unassignedOwners = props.unassignedOwners, spaceAssignedOwners = props.spaceAssignedOwners, spaceOptions = props.spaceOptions, getTableOptions = props.getTableOptions, spaceSelected = props.spaceSelected, onSpaceSelected = props.onSpaceSelected, onSpaceOptionSelected = props.onSpaceOptionSelected, onTableSelected = props.onTableSelected, onOwnerReturn = props.onOwnerReturn, onOwnerRemove = props.onOwnerRemove, onOwnerRename = props.onOwnerRename;
    var checkOwnerAssigned = function (owner) {
        if (spaceSelected) {
            onSpaceSelected(owner, spaceSelected);
        }
    };
    var selectSpace = function (event, owner) {
        // Set floor and space for active owner.
        onSpaceOptionSelected(owner, event.value);
    };
    var selectTable = function (event, owner) {
        onTableSelected(owner, event.value);
    };
    var returnOwner = function (owner) {
        if (spaceSelected) {
            onOwnerReturn(owner, spaceSelected);
        }
    };
    var getSelectedOption = function (owner) {
        if (owner.table) {
            return {
                value: owner.table.letter,
                label: owner.table.letter,
                disabled: true,
            };
        }
        return null;
    };
    var renderSpaceAssigned = function () {
        if (spaceSelected === null) {
            return null;
        }
        return (React.createElement(TableContainer, null,
            React.createElement(TableTitle, null,
                "Space ",
                spaceSelected ? spaceSelected.title : ''),
            spaceAssignedOwners && spaceAssignedOwners.length > 0 ? (React.createElement(Table, { style: { marginTop: 4, marginBottom: 0 } },
                React.createElement(TableHead, null,
                    React.createElement("tr", null,
                        React.createElement(TableHeadCell, null, "Name"),
                        React.createElement(TableHeadCell, { style: { width: 80 } }, "Table"))),
                React.createElement(TableBody, null, spaceAssignedOwners.map(function (owner) {
                    return (React.createElement(TableRow, { key: owner.key },
                        React.createElement(TableCell, null,
                            React.createElement(TableCellContent, { style: {
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                } },
                                React.createElement(CheckBox, { checked: true, onChange: function () { return returnOwner(owner); } }),
                                React.createElement(NameCell, { owner: owner, onOwnerRename: onOwnerRename }, owner.name))),
                        React.createElement(TableCell, { style: { width: 80, padding: 0 } },
                            React.createElement(BlueSelect, { options: getTableOptions(owner.space), onChange: function (value) { return selectTable(value, owner); }, initValue: getSelectedOption(owner) }))));
                })))) : (React.createElement(EmptyContentTitle, null, "Select unassigned names to this space."))));
    };
    var renderUnassigned = function () {
        return (React.createElement(TableContainer, null,
            React.createElement(TableTitle, null, "Unassigned people"),
            unassignedOwners && unassignedOwners.length > 0 ? (React.createElement(Table, { style: { marginTop: 4, marginBottom: 0 } },
                React.createElement(TableHead, null,
                    React.createElement("tr", null,
                        React.createElement(TableHeadCell, null, "Name"),
                        React.createElement(TableHeadCell, { style: { width: 80 } }, "Space"))),
                React.createElement(TableBody, null, unassignedOwners.map(function (owner) {
                    return (React.createElement(SelectableRow, { key: owner.key, isSelected: selectedOwner === owner },
                        React.createElement(TableCell, { onClick: function () { return onOwnerSelect(owner); } },
                            React.createElement(TableCellContent, { style: {
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                } },
                                spaceSelected && React.createElement(CheckBox, { checked: false, onChange: function () { return checkOwnerAssigned(owner); } }),
                                React.createElement(NameCell, { owner: owner, onOwnerRename: onOwnerRename }, owner.name),
                                selectedOwner === owner && (React.createElement(FiTrash2, { size: 14, color: colors.RED, onClick: function () { return onOwnerRemove(owner); }, style: { float: 'right' } })))),
                        React.createElement(TableCell, { style: {
                                padding: 0,
                                width: 80,
                            } },
                            React.createElement(BlueSelect, { options: spaceOptions, onChange: function (e) { return selectSpace(e, owner); } }))));
                })))) : (React.createElement(EmptyContentTitle, null, "No owners to assign"))));
    };
    var renderRestAssigned = function () {
        return (React.createElement(TableContainer, null,
            React.createElement(TableTitle, null, "All assigned names"),
            assignedOwners && assignedOwners.length > 0 ? (React.createElement(Table, { style: { marginTop: 4, marginBottom: 0 } },
                React.createElement(TableHead, null,
                    React.createElement("tr", null,
                        React.createElement(TableHeadCell, { style: { width: '60%' } }, "Name"),
                        React.createElement(TableHeadCell, { style: { paddingLeft: 8 } }, "F"),
                        React.createElement(TableHeadCell, { style: { paddingLeft: 8 } }, "S"),
                        React.createElement(TableHeadCell, { style: { paddingLeft: 8 } }, "T"),
                        React.createElement(TableHeadCell, null))),
                React.createElement(TableBody, null, assignedOwners.map(function (owner) {
                    return (React.createElement(TableRow, { key: owner.key, style: { backgroundColor: colors.WHITE_WARM } },
                        React.createElement(TableCell, { style: { width: '60%', paddingLeft: 2 } },
                            React.createElement(NameCell, { owner: owner, onOwnerRename: onOwnerRename })),
                        React.createElement(TableCell, { style: { paddingLeft: 2 } }, owner.floor && owner.floor.title),
                        React.createElement(TableCell, { style: { paddingLeft: 2 } }, owner.space && owner.space.title),
                        React.createElement(TableCell, { style: { paddingLeft: 2 } }, owner.table ? owner.table.letter : '-'),
                        React.createElement(TableCell, { style: { paddingLeft: 2 } },
                            React.createElement(BurgerMenu, { options: [
                                    { label: 'Remove allocation', handler: function () { return onOwnerReturn(owner, owner.space); } },
                                    {
                                        label: 'Delete name',
                                        handler: function () { return __awaiter(void 0, void 0, void 0, function () {
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, onOwnerReturn(owner, owner.space)];
                                                    case 1:
                                                        _a.sent();
                                                        onOwnerRemove(owner);
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); },
                                    },
                                ] }))));
                })))) : (React.createElement(EmptyContentTitle, null, "No names assigned yet."))));
    };
    return (React.createElement(Container, null,
        renderSpaceAssigned(),
        renderUnassigned(),
        renderRestAssigned()));
};
export default EmployeeLists;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=EmployeeLists.js.map